export enum InputNames {
  Category = 'category',
  VehiclePrice = 'vehiclePrice',
  InitialPayment = 'initialPayment',
  Amount = 'amount',
  Duration = 'duration',
}

export type LoanSelectionProps = {
  [InputNames.Amount]: number;
  [InputNames.Duration]: number;
  [InputNames.Category]: number;
  [InputNames.VehiclePrice]: number;
  [InputNames.InitialPayment]: number;
};

export type LoanSelectionStore = {
  // Client-only memory of the last confirmed selection, carried across page navigations.
  loanSelection: LoanSelectionProps | null;
  setLoanSelection: (props: LoanSelectionProps) => void;
};
